// extracted by mini-css-extract-plugin
module.exports = {"light-grey":"#DCDCDC","contentWidth":"100%","pageTabs":"PageTabs_pageTabs__2slSZ"};